module.exports = __webpack_public_path__ + "static/EkalavyaAward-3f25d412fcc2dc03b8b52e24a48279dd.png";